import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "../components/Logo";
import { api, errMsg } from "../lib/api";

export default function FindOrder() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/orders/lookup", { email });
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain grid-lines min-h-screen bg-[#07070b] px-5 py-8 md:px-10">
      <Link to="/" data-testid="find-order-home-link"><Logo /></Link>
      <div className="mx-auto mt-16 max-w-lg border border-white/10 bg-[#0b0b11]/90 p-8 md:p-10" data-testid="find-order-container">
        <h1 className="font-display text-6xl uppercase leading-none text-white">Find my order</h1>
        {sent ? (
          <div className="mt-6" data-testid="find-order-sent">
            <MailCheck className="h-8 w-8 text-[#a259ff]" />
            <p className="mt-4 text-slate-300">If we have orders for <b className="text-white">{email}</b>, we've emailed the links to them. Check your inbox and spam folder.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <p className="text-slate-300">Enter the email you used at checkout and we'll send you the links to your order pages.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="find-order-email-input" className="h-12 w-full border border-white/15 bg-black/40 px-4 text-sm text-white placeholder:text-slate-500 focus:border-[#a259ff] focus:outline-none" />
            <button disabled={busy} data-testid="find-order-submit" className="flex h-12 w-full items-center justify-center gap-2 bg-[#a259ff] font-mono text-xs font-bold uppercase tracking-widest text-black disabled:opacity-60">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Email my order links
            </button>
          </form>
        )}
        <Link to="/account" className="mt-6 block border-t border-white/10 pt-5 text-center font-mono text-xs uppercase tracking-widest text-violet-300 hover:text-white" data-testid="find-order-account-link">Or sign in with Google to see all your orders</Link>
      </div>
    </div>
  );
}
